import { useMemo } from 'react';

import type { DecisionMaker } from 'src/app/pages/petitionGamma/details/shared/types';

import { useDecisionMakers } from '../useDecisionMakers';
import { useMediaHits } from '../useMediaHits';
import { useSupporterVoices } from '../useSupporterVoices';
import { useUpdates } from '../useUpdates';
import { useVotersPercentage } from '../useVotersPercentage';

type Result = ModelHookResult<{
	sectionIsShown: boolean;
	decisionMakers: {
		isShown: boolean;
		count: number;
		first: { displayName: string };
		dms: readonly DecisionMaker[];
	};
	mediaHits: {
		isShown: boolean;
		count: number;
	};
	updates: {
		isShown: boolean;
		count: number;
	};
	voters: {
		isShown: boolean;
		percentage: number;
	};
	supporterVoices: {
		isShown: boolean;
		count: number;
	};
}>;

export const useContentSummary = (): Result => {
	const { data: voters } = useVotersPercentage();
	const { data: updates } = useUpdates();
	const { data: decisionMakers } = useDecisionMakers();
	const { data: mediaHits } = useMediaHits();
	const { data: supporterVoices } = useSupporterVoices();

	return useMemo(() => {
		return {
			data: {
				sectionIsShown: decisionMakers.isShown || mediaHits.isShown || updates.isShown || voters.isShown,
				decisionMakers,
				mediaHits,
				updates,
				voters,
				supporterVoices,
			},
			actions: {},
		};
	}, [decisionMakers, mediaHits, supporterVoices, updates, voters]);
};
